import type { ErrorCode } from '@budgetx/shared';

export class ClientApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ErrorCode | 'network' | 'parse',
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ClientApiError';
  }
}
